var React = require('react');

function RectangleFlipInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.399 27L27 8.399 18.599 0 0 18.6z"}));
}

RectangleFlipInline.defaultProps = {"viewBox":"0 0 27 27","fill":"#c586a8"};

module.exports = RectangleFlipInline;

RectangleFlipInline.default = RectangleFlipInline;
